import { createApp, ref } from "vue";
import router from "./router";
import App from "./App.vue";
import userMonitor from "./services/userMonitor";
import LoggingService from "./services/logging-service";

/* import the fontawesome core */
import { library } from "@fortawesome/fontawesome-svg-core";

/* import specific icons */
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

/* import font awesome icon component */
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import translations from "./translations.yml";
import { getCountry, getLanguage } from "./services/url-service";

// get params
let language = getLanguage();
let country = getCountry();
/* add icons to the library */
library.add(faChevronRight);

(async () => {
  const config = await fetch("./env.json").then((response) => response.json());
  const $t = ref({
    ...translations["en"],
    ...translations["en"]["US"],
    ...translations[language],
    ...translations[language]?.[country],
  });
  const locale = ref(`${language}_${country}`);
  const loggingService = new LoggingService(userMonitor, locale.value);

  createApp(App)
    .provide("config", config)
    .provide("$t", $t)
    .provide("locale", locale)
    .provide("userMonitor", userMonitor)
    .provide("loggingService", loggingService)
    .provide("setLocale", (c, l) => {
      country = c || country;
      language = l || language;

      locale.value = `${language}_${country}`;

      $t.value = {
        ...translations[language],
        ...translations[language]?.[country],
      };
    })
    .component("font-awesome-icon", FontAwesomeIcon)
    .use(router)
    .mount("#app");

  userMonitor.init({
    applicationId: "dd59f938-7544-4bd5-90bf-5485618e25ed",
    clientToken: "pub1b2d42cbf11091902d983b97a4b18cb7",
    site: "datadoghq.com",
    service: "opportunity-router",
    env: config.environment,
    sampleRate: 10,
    trackInteractions: true,
    defaultPrivacyLevel: "mask-user-input",
  });
  userMonitor.start();
})();
